var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex align-items-end flex-wrap gap-2" }, [
    _c(
      "div",
      { staticStyle: { "min-width": "320px", "max-width": "480px" } },
      [
        _c("custom-drop-down", {
          attrs: {
            fieldkey: "paymentJournalId",
            fieldname: "label",
            label: "Seleccione Jornal de Pagos:",
            options: _vm.journalOptions,
            placeholder: "Seleccione"
          },
          model: {
            value: _vm.selectedJournal,
            callback: function($$v) {
              _vm.selectedJournal = $$v
            },
            expression: "selectedJournal"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "d-flex ml-2" },
      [
        _c(
          "action-button",
          {
            attrs: {
              i: "fas fa-times-circle",
              variant: "outline-danger px-3 mr-2"
            },
            on: {
              click: function($event) {
                return _vm.$emit("on-cancel")
              }
            }
          },
          [_vm._v(" Cancelar ")]
        ),
        _c(
          "action-button",
          {
            attrs: {
              disabled: !_vm.selectedJournal,
              i: "fas fa-arrow-right",
              variant: "success px-3"
            },
            on: { click: _vm.onConfirm }
          },
          [_vm._v(" Continuar ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }